import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default () => {
    gsap.registerPlugin(ScrollTrigger);
    gsap.set('.parallaxImage', {
        backgroundPosition: '50% 100%',
    });
    gsap.to('.parallaxImage', {
        backgroundPosition: '50% 0%',
        ease: 'none',
        scrollTrigger: {
            trigger: '.parallaxImage',
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
        },
    });
    gsap.set('.parallaxImage2', {
        backgroundPosition: '50% 100%',
    });
    gsap.to('.parallaxImage2', {
        backgroundPosition: '50% 0%',
        ease: 'none',
        scrollTrigger: {
            trigger: '.parallaxImage2',
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
        },
    });
    const sliderImages = document.querySelectorAll('.parallaxImage1');
    sliderImages.forEach((image) => {
        gsap.to(image, {
            backgroundPosition: '50% 0%',
            ease: 'none',
            scrollTrigger: {
                trigger: image,
                start: 'top top',
                end: 'bottom top',
                scrub: true,
            },
        });
    });
};
